import { apiStore } from '@/stores/ApiStore';
import type {
  PaymentAnalyticsPaymentMethod,
  SubscriptionStatus,
  SubscriptionStatusResponse,
} from '@/types/api';

interface TrackSuccessfulPaymentAnalyticsParams {
  paymentMethod: PaymentAnalyticsPaymentMethod;
  planId?: string;
  subscription?: SubscriptionStatus | null;
  subscriptionResponse?: SubscriptionStatusResponse | null;
}

export function getPaymentAnalyticsPaywallVersion(
  pathname = window.location.pathname,
): string | undefined {
  const match = pathname.match(/^\/paywall\/(v\d+)(?:\/|$)/);
  return match?.[1];
}

export function getSubscriptionStatusFromResponse(
  response: SubscriptionStatusResponse | null | undefined,
): SubscriptionStatus | null {
  if (!response) {
    return null;
  }

  if ('subscriptionId' in response) {
    return response;
  }

  return response.status;
}

export async function trackSuccessfulPaymentAnalytics({
  paymentMethod,
  planId,
  subscription,
  subscriptionResponse,
}: TrackSuccessfulPaymentAnalyticsParams): Promise<void> {
  const resolvedSubscription = subscription
    ?? getSubscriptionStatusFromResponse(subscriptionResponse);

  if (!resolvedSubscription?.subscriptionId) {
    return;
  }

  await apiStore.recordPaymentAnalyticsEvent({
    eventType: 'paywall.payment.succeeded',
    paymentMethod,
    subscriptionId: resolvedSubscription.subscriptionId,
    planId: planId ?? resolvedSubscription.plan.planId,
    paywallVersion: getPaymentAnalyticsPaywallVersion(),
  });
}
